(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
  class clarityLookBook extends HTMLElement {
    constructor() {
      super();

      this.injectVendorScripts();
      this.querySelectorAll('.clarity-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem);
      });
    }

    async injectVendorScripts() {
      if (!window.FloatingUICore) {
        const script = document.createElement('script');
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0');
        document.head.appendChild(script);
      }
      if (!window.FloatingUIDOM) {
        await new Promise((r) => setTimeout(r, 500));

        const script = document.createElement('script');
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1');
        document.head.appendChild(script);
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button');
      const tooltip = elem.querySelector('.clarity-tooltip');

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [window.FloatingUIDOM.offset(0), window.FloatingUIDOM.autoPlacement()],
        }).then(({ x, y }) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          });
        });
      }

      function showTooltip() {
        tooltip.classList.add('show');
        update();
      }

      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show');
          tooltip.classList.add('hiding');
          setTimeout(() => {
            tooltip.classList.remove('hiding');
          }, 200);
        }, 100);
      }

      if (window.matchMedia('(pointer: coarse)').matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener);
        });
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener);
        });
      }
    }
  }
  customElements.define('clarity-lookbook', clarityLookBook);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video-new"] && !Shopify.designMode) return;
  try {
    
  class KsShoppableVideos extends HTMLElement {
    constructor() {
      super();
      /*
    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
      script.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(script)
    }
*/
      setTimeout(() => {
        const slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions());

        slider.on('slideChange', () => {
          this.querySelector('.swiper').classList.add('swiper-is-changing');
          this.onSlideChange();
        });

        slider.on('slideChangeTransitionEnd', () => {
          this.querySelector('.swiper').classList.remove('swiper-is-changing');
        });
      }, 500);

      this.querySelectorAll('.clarity-shoppable-videos-btn-play').forEach((btn) => {
        btn.addEventListener('click', () => {
          const video = btn.closest('.clarity-shoppable-videos-video-wrapper').querySelector('video');
          this.onVideoPlay(video);
        });
      });

      this.querySelectorAll('video').forEach((video) => {
        video.addEventListener('click', () => {
          this.onVideoPlay(video);
        });
      });

      const lazyVideosObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.play();
            }
          });
        },
        { rootMargin: '0px 0px 300px 0px' }
      );

      this.querySelectorAll('video[data-autoplay="true"]').forEach((el) => {
        lazyVideosObserver.observe(el);
      });
    }

    splideOptions() {
      const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1;

      /** @type {SwiperOptions} */
      const options = {
        rewind: true,
        speed: Number(this.dataset.sliderSpeed),
        breakpoints: {
          0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
          576: { slidesPerView: Number(this.dataset.breakpointSm) },
          768: { slidesPerView: Number(this.dataset.breakpointMd) },
          992: { slidesPerView: Number(this.dataset.breakpointLg) },
          1200: { slidesPerView: Number(this.dataset.breakpointXl) },
          1400: { slidesPerView: Number(this.dataset.breakpointXxl) },
        },
        navigation: {
          enabled: this.dataset.sliderNav === 'true',
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        },
        pagination: {
          enabled: this.dataset.sliderPagination === 'true',
          type: this.dataset.sliderPaginationType,
          el: '.swiper-pagination',
          dynamicBullets: true,
          dynamicMainBullets: 2,
          renderFraction: function (currentClass, totalClass) {
            return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`;
          },
        },
        scrollbar: {
          enabled: this.dataset.sliderScrollbar === 'true',
          el: this.querySelector('.swiper-scrollbar'),
          draggable: true,
          // hide: true
        },
        autoplay:
          this.dataset.sliderAutoplay !== '0' ? { delay: Number(this.dataset.sliderAutoplay) * 1000 } : undefined,
        watchSlidesProgress: true,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
      };
      return options;
    }

    onSlideChange() {
      this.querySelectorAll('.clarity-shoppable-videos-card').forEach((elem) => {
        elem.setAttribute('data-is-playing', 'false');
        elem.querySelector('video')?.pause();
      });
    }

    onVideoPlay(video) {
      const card = video.closest('.clarity-shoppable-videos-card');

      this.querySelectorAll('.clarity-shoppable-videos-card').forEach((elem) => {
        if (elem.dataset.index !== card.dataset.index) {
          elem.setAttribute('data-is-playing', 'false');
          elem.querySelector('video')?.pause();
        }
      });

      if (card.dataset.isPlaying === 'true') {
        card.setAttribute('data-is-playing', 'false');
        video.pause();
      } else {
        card.setAttribute('data-is-playing', 'true');
        video.muted = false;
        video.play();
      }
    }
  }
  customElements.define('clarity-shoppable-videos', KsShoppableVideos);

  } catch(e) { console.error(e); }
})();
})();
